export default __webpack_public_path__ + "static/media/filter_category_blue.016b43dc.svg";